import * as tslib_1 from "tslib";
import { QueryList, ElementRef, AfterViewInit, NgZone, OnInit } from '@angular/core';
import { AgmInfoWindow, AgmMarker } from '@agm/core';
import { GoogleService } from '../../google/google.service';
import { Airport } from '../models/airport.model';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { AgmSnazzyInfoWindow } from '@agm/snazzy-info-window';
var LocalActivitiesComponent = /** @class */ (function () {
    function LocalActivitiesComponent(_google, _zone) {
        this._google = _google;
        this._zone = _zone;
    }
    LocalActivitiesComponent.prototype.onClickNextPage = function () {
        this.getRelatedPage('next');
    };
    LocalActivitiesComponent.prototype.onClickPrevPage = function () {
        this.getRelatedPage('previous');
    };
    LocalActivitiesComponent.prototype.getRelatedPage = function (pageType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (pageType === 'previous') {
                    this.activitiesPromise = new StatefulPromise(Promise.resolve(this.activitiesPromise.value.getPrevPage()));
                }
                else {
                    this.activitiesPromise = new StatefulPromise(this.activitiesPromise.value.getNextPage());
                }
                this.activitiesPromise.promise.then(function (res) {
                    if (_this.activities.length < 1) {
                        return;
                    }
                    _this.latLngBounds = new google.maps.LatLngBounds();
                    _this.activities.forEach(function (activity) {
                        _this.latLngBounds.extend(new google.maps.LatLng(activity.geometry.location.lat(), activity.geometry.location.lng()));
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    LocalActivitiesComponent.prototype.onClickActivityType = function (activityType) {
        this.selectedType = activityType;
        this.getActivities();
    };
    LocalActivitiesComponent.prototype.getActivities = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (['fishing', 'skiing', 'golf'].includes(this.selectedType)) {
                    this.activitiesPromise = new StatefulPromise(this._google.nearbySearch({
                        rankBy: google.maps.places.RankBy.DISTANCE,
                        keyword: this.selectedType,
                        location: { lat: this.airport.location.lat, lng: this.airport.location.lon }
                    }));
                }
                else if (this.selectedType === 'national-and-state-parks') {
                    this.activitiesPromise = new StatefulPromise(this._google.nearbySearch({
                        rankBy: google.maps.places.RankBy.DISTANCE,
                        keyword: 'national and state parks',
                        location: { lat: this.airport.location.lat, lng: this.airport.location.lon }
                    }));
                }
                else {
                    this.activitiesPromise = new StatefulPromise(this._google.nearbySearch({
                        rankBy: google.maps.places.RankBy.DISTANCE,
                        type: this.selectedType,
                        location: { lat: this.airport.location.lat, lng: this.airport.location.lon }
                    }));
                }
                this.latLngBounds = new google.maps.LatLngBounds();
                this.latLngBounds.extend(new google.maps.LatLng(this.airport.location.lat, this.airport.location.lon));
                this.activitiesPromise.promise.then(function (res) {
                    /* if (this.activities.length < 1) {
                      return;
                    } */
                    _this.activities.forEach(function (activity) {
                        _this.latLngBounds.extend(new google.maps.LatLng(activity.geometry.location.lat(), activity.geometry.location.lng()));
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(LocalActivitiesComponent.prototype, "activities", {
        get: function () {
            if (!this.activitiesPromise || this.activitiesPromise.state !== PromiseState.Fulfilled) {
                return null;
            }
            return this.activitiesPromise.value.places;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocalActivitiesComponent.prototype, "hasNextPage", {
        get: function () {
            if (!this.activitiesPromise || this.activitiesPromise.state !== PromiseState.Fulfilled) {
                return false;
            }
            return this.activitiesPromise.value.hasNextPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocalActivitiesComponent.prototype, "hasPrevPage", {
        get: function () {
            if (!this.activitiesPromise || this.activitiesPromise.state !== PromiseState.Fulfilled) {
                return false;
            }
            return this.activitiesPromise.value.hasPrevPage;
        },
        enumerable: true,
        configurable: true
    });
    LocalActivitiesComponent.prototype.ngOnInit = function () {
        if (this.tabType === 'lodging') {
            this.selectedType = 'lodging';
        }
        else if (this.tabType === 'restaurant') {
            this.selectedType = 'restaurant';
        }
        else {
            this.selectedType = 'national-and-state-parks';
        }
        // this.selectedType = 'park';
    };
    LocalActivitiesComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._google.promise];
                    case 1:
                        _a.sent();
                        this.getActivities();
                        this.$containerEl = $(this.listEl.nativeElement);
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalActivitiesComponent.prototype.getIconUrl = function (activity) {
        return GoogleService.getIconUrl(activity, this.selectedType);
    };
    /**
     * Returns a jQuery element container for the given attraction.
     */
    LocalActivitiesComponent.prototype.getActivityEl = function (activity) {
        var i = this.activities.indexOf(activity);
        if (i < 0) {
            return null;
        }
        var el = this.activityCardEls.toArray()[i];
        return $(el.nativeElement);
    };
    /**
     * Scrolls the attractions list to the specified attraction, marking it as selected.
     */
    LocalActivitiesComponent.prototype.scrollToActivity = function (activity) {
        var $el = this.getActivityEl(activity);
        if (!$el) {
            return;
        }
        var position = $el[0].offsetTop;
        this.$containerEl.stop(true);
        this.$containerEl.animate({ scrollTop: position }, 500);
    };
    /**
     * Hover handler for attraction cards in the list
     */
    LocalActivitiesComponent.prototype.onActivityItemHover = function (activity, hover) {
        if (hover) {
            this.selectedActivity = activity;
        }
    };
    LocalActivitiesComponent.prototype.onAirportMarkerClick = function () {
        this.infoWindowOpen(this.airportInfoWindow, this.airportMarker);
    };
    LocalActivitiesComponent.prototype.onAirportMarkerHover = function (hover) {
        if (hover) {
            this.infoWindowOpen(this.airportInfoWindow, this.airportMarker);
        }
        else {
            this.infoWindowClose(this.airportInfoWindow);
        }
    };
    LocalActivitiesComponent.prototype.onActivityMarkerHover = function (activity, hover) {
        var _this = this;
        clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(function () {
            if (hover) {
                _this.selectedActivity = activity;
                _this.scrollToActivity(activity);
            }
        }, 400);
    };
    LocalActivitiesComponent.prototype.infoWindowOpen = function (infoWindow, marker) {
        if (marker === void 0) { marker = null; }
        infoWindow.hostMarker = marker;
        // Run outside angular to avoid triggering an endless cycle of change detection:
        // https://github.com/SebastianM/angular-google-maps/issues/796
        this._zone.runOutsideAngular(function () {
            infoWindow.open();
        });
    };
    LocalActivitiesComponent.prototype.infoWindowClose = function (infoWindow) {
        this._zone.runOutsideAngular(function () {
            infoWindow.close();
        });
    };
    return LocalActivitiesComponent;
}());
export { LocalActivitiesComponent };
